import formatDate from 'date-fns/format'
import parseDate from 'date-fns/parse'
import parseISO from 'date-fns/parseISO'
import getDay from 'date-fns/getDay'
import addDays from 'date-fns/addDays'
// import getDayOfYear from 'date-fns/getDayOfYear'
import isPast from 'date-fns/isPast'

// export function getDaysUntil(date) {
//   date = parseISO(date)
//   const today = getDayOfYear(new Date())
//   const workshopDay = getDayOfYear(date)
//   return workshopDay - today
// }

export function getDateRangeText(startDate, days = 1) {
  const format = 'MMM do'
  startDate = parseISO(startDate)

  if (days === 1) {
    return formatDate(startDate, format + ', yyyy')
  } else {
    const start = formatDate(startDate, format)
    const end = formatDate(addDays(startDate, days - 1), format + ', yyyy')
    return `${start} - ${end}`
  }
}

export function eventIsPast(startDate, offset = 0) {
  return isPast(addDays(parseISO(startDate), offset))
}

export function getWorkshopDaysOfWeek(date, days = 2) {
  date = parseISO(date)
  const start = getDay(date)
  const end = getDay(addDays(date, days - 1))
  return { start, end }
}
